import { createContext, useContext } from 'react';

export interface ArgRef {
	stepId: string;
	field: string;
}

interface CanvasValue {
	/** The argument whose picker is open: from its slot, or from a wire dropped on empty canvas. */
	picking: ArgRef | null;
	setPicking: (ref: ArgRef | null) => void;
}

export const CanvasContext = createContext<CanvasValue | null>(null);

export const useCanvas = (): CanvasValue => {
	const value = useContext(CanvasContext);
	if (!value) throw new Error('Canvas cards must be rendered inside <FlowCanvas>');
	return value;
};
